import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import AudienceModal from "../modals/AudienceModal/AudienceModal";

export function StepAudience({ data, updateData, setIsValid, showErrors }) {
  const theme = useTheme();

  const { audience_id = null, audience = null } = data;

  const [open, setOpen] = useState(false);

  const isValid = Boolean(audience_id);

  useEffect(() => {
    setIsValid(isValid);
  }, [isValid, setIsValid]);

  const listError = showErrors && !audience_id;

  return (
    <Box>
      <Typography sx={{ fontSize: 14, mb: 1 }}>
        {audience ? "Listagem Selecionada" : "Selecione uma Listagem"}
      </Typography>

      {!audience ? (
        <Typography
          sx={{
            color: listError
              ? theme.palette.custom.red[600]
              : theme.palette.custom.gray[500],
            fontSize: 16,
            mb: 2,
          }}
        >
          -- Nenhuma Listagem Selecionada --
        </Typography>
      ) : (
        <Box sx={{ mb: 2 }}>
          <Typography fontSize={16}>
            <b>Título:</b> {audience.title}
          </Typography>

          <Typography fontSize={16}>
            <b>Descrição:</b> {audience.description}
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        onClick={() => setOpen(true)}
        sx={{
          textTransform: "none",
          borderRadius: 2,
          px: 3,
          py: 1.5,

          ...(listError
            ? {
                backgroundColor: theme.palette.custom.red[100],
                color: theme.palette.custom.red[600],
                "&:hover": {
                  backgroundColor: theme.palette.custom.red[200],
                },
              }
            : audience
              ? {
                  backgroundColor: theme.palette.custom.purple[500],
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: theme.palette.custom.purple[700],
                  },
                }
              : {
                  backgroundColor: theme.palette.custom.gray[300],
                  color: theme.palette.custom.gray[700],
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: theme.palette.custom.gray[400],
                    boxShadow: "none",
                  },
                }),
        }}
      >
        {audience ? "Trocar Listagem" : "Selecionar Listagem"}
      </Button>

      <AudienceModal
        open={open}
        onClose={() => setOpen(false)}
        audience_id={audience_id}
        updateData={updateData}
      />
    </Box>
  );
}
